function isValidSetupUrl(receivedUrl: string) {
  const urls = [
    '/setup/pre-signup',
    '/lead-profile',
    '/setup/requisites',
    '/setup/categories',
    '/setup/create-password',
  ];
  return urls.includes(receivedUrl);
}

export { isValidSetupUrl };
